import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../../services/i18nService';

import styles from './DrawingCollapsedView.scss';
import DrawingService from '../../../../../../../services/DrawingService';

const DrawingCollapsedView = (props) => {
    const {
        inProgressDrawing,
        closeModal,
        expandModal,
        saveCallback,
        connectedDialog,
        shouldAutoFocus,
    } = props;
    const getPreview = () => {
        const url = inProgressDrawing?.toDataURL();
        if (url) {
            return <img src={url} alt="" />;
        }

        return <p className="emptyDrawingPlaceholder">{t('essay.drawing.collapsed.draftDrawing')}</p>;
    };

    const saveDrawing = () => {
        saveCallback(inProgressDrawing);
    };

    const editDrawing = () => {
        expandModal();
    };

    const modalContinueButtonClasses = `${styles.continue} 
    ${DrawingService.isCollapsibleDrawingModalEnabled() ? `${styles.altBorderStyle}` : ''}`;
    const modalDiscardButtonClasses = `${styles.discard} 
    ${DrawingService.isCollapsibleDrawingModalEnabled() ? `${styles.modalDiscardBoldAndUnderline}` : ''}`;

    return (
        <div className={styles.collapsedModal}>
            <div className={styles.drawingPreview}>
                { getPreview() }
            </div>

            <div>
                <h3>{t('essay.drawing.collapsed.draftDrawingTitle')}</h3>
                <p>{t('essay.drawing.collapsed.description')}</p>
                <div className={styles.actions}>
                    <button
                        className={modalContinueButtonClasses}
                        onClick={editDrawing}
                        aria-haspopup="dialog"
                        aria-controls={connectedDialog}
                        aria-expanded={false}
                        /* So that the focus shifts to the button that reopens the modal */
                        /* eslint-disable-next-line jsx-a11y/no-autofocus */
                        autoFocus={shouldAutoFocus}
                    >
                        {t('essay.drawing.edit')}
                    </button>
                    <button className={modalDiscardButtonClasses} onClick={closeModal}>{t('essay.drawing.collapsed.discard')}</button>
                    <button className={styles.insert} onClick={saveDrawing}>{t('essay.drawing.collapsed.insertDrawing')}</button>
                </div>
            </div>
        </div>
    );
};


DrawingCollapsedView.propTypes = {
    inProgressDrawing: PropTypes.object,
    closeModal: PropTypes.func.isRequired,
    expandModal: PropTypes.func.isRequired,
    saveCallback: PropTypes.func.isRequired,
    connectedDialog: PropTypes.string.isRequired,
    shouldAutoFocus: PropTypes.bool.isRequired,
};


export default DrawingCollapsedView;
